import { render } from "./BotOniel.vue?vue&type=template&id=f009d1b0"
import script from "./BotOniel.vue?vue&type=script&lang=js"
export * from "./BotOniel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__